module.exports = __webpack_public_path__ + "img/20_two_pma_560.84ca498a.jpg";